export const NEXT_PUBLIC_GRAPHQL_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT || 'https://stellate.firsttable.net/graphql';

export const NEXT_PUBLIC_GRAPHQL_BUILD_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_BUILD_ENDPOINT || 'https://stellate.firsttable.net/graphql';

/**
 * Direct GraphQL URL for mutations when query traffic uses Stellate; unset means mutations use the query URL.
 * Must use `process.env.NEXT_PUBLIC_…` directly — Next.js does not inline env vars when destructuring `process.env`.
 */
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
export const NEXT_PUBLIC_GRAPHQL_MUTATION_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_MUTATION_ENDPOINT;

export const NEXT_PUBLIC_APOLLO_ORIGIN = process.env.NEXT_PUBLIC_APOLLO_ORIGIN || 'firsttabe@web';

export const NEXT_PUBLIC_DEFAULT_TZ = process.env.NEXT_PUBLIC_DEFAULT_TZ || 'Pacific/Auckland';

export const NEXT_PUBLIC_FIREBASE_DATABASE =
  process.env.NEXT_PUBLIC_FIREBASE_DATABASE || 'https://first-table.firebaseio.com/';

// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
const firebaseApiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY;

// Fails the build rather than shipping a hardcoded Firebase web API key fallback.
if (!firebaseApiKey) {
  throw new Error('Missing required environment variable: NEXT_PUBLIC_FIREBASE_API_KEY');
}

export const NEXT_PUBLIC_FIREBASE_API_KEY = firebaseApiKey;

export const NEXT_PUBLIC_FIREBASE_PROJECT_ID =
  process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'first-table-1524116746062';

export const NEXT_PUBLIC_STRIPE_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY || 'pk_live_Jow3lX746zGMy0lGhvQ5YjQE';

export const NEXT_PUBLIC_FACEBOOK_APP_ID =
  process.env.NEXT_PUBLIC_FACEBOOK_APP_ID || '672153162860753';

export const NEXT_PUBLIC_GOOGLE_APP_ID =
  process.env.NEXT_PUBLIC_GOOGLE_APP_ID ||
  '949599212204-us502nfrmomq5occ5jg9rsj7c6a5tp4o.apps.googleusercontent.com';

export const NEXT_PUBLIC_LOGIN_METHODS = (
  process.env.NEXT_PUBLIC_LOGIN_METHODS ||
  'email-universal, validate-member, Facebook, google, apple'
)
  .split(',')
  .map((i) => i.trim().toLowerCase());

export const NEXT_PUBLIC_APPLE_APP_ID =
  process.env.NEXT_PUBLIC_APPLE_APP_ID || 'com.firsttable.www';

export const NEXT_PUBLIC_SERVER_ENDPOINT =
  process.env.NEXT_PUBLIC_SERVER_ENDPOINT || 'https://admin.firsttable.com/';

export const ADMIN_URL = process.env.NEXT_PUBLIC_MANAGE_URL || 'https://admin.firsttable.com/';

export const CMS_URL = process.env.NEXT_PUBLIC_CMS_URL || ADMIN_URL;

export const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL || 'https://www.firsttable.co.nz/'; // This must end with a slash

export const REGULAR_TABLE_NAME = 'Regular Table';

export const NEXT_PUBLIC_TOP_UP_ENABLED = process.env.NEXT_PUBLIC_TOP_UP_ENABLED || false;

export const NEXT_PUBLIC_GROWTHBOOK_FEATURES_ENDPOINT =
  process.env.NEXT_PUBLIC_GROWTHBOOK_FEATURES_ENDPOINT ||
  'https://cdn.growthbook.io/api/features/sdk-fxcKGAweTl1FCYI';

export const NEXT_PUBLIC_GROWTHBOOK_INGESTOR_HOST =
  process.env.NEXT_PUBLIC_GROWTHBOOK_INGESTOR_HOST || 'https://us1.gb-ingest.com';

export const NEXT_PUBLIC_GROWTHBOOK_DISABLED =
  process.env.NEXT_PUBLIC_GROWTHBOOK_DISABLED === 'true';

// Enables the GrowthBook DevTools browser extension to detect the SDK and force variations. Defaults to disabled; opt in locally and on preview deployments only.
export const NEXT_PUBLIC_GROWTHBOOK_DEV_MODE =
  process.env.NEXT_PUBLIC_GROWTHBOOK_DEV_MODE === 'true';

export const NEXT_PUBLIC_GROWTHBOOK_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_GROWTHBOOK_LOGGING_ENABLED === 'true';

export const NEXT_PUBLIC_GTM_DISABLED = process.env.NEXT_PUBLIC_GTM_DISABLED === 'true';

export const NEXT_PUBLIC_GTM_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_GTM_LOGGING_ENABLED === 'true';

// Snapchat
export const NEXT_PUBLIC_SNAPCHAT_DISABLED = process.env.NEXT_PUBLIC_SNAPCHAT_DISABLED === 'true';
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
export const NEXT_PUBLIC_SNAPCHAT_PIXEL_ID = process.env.NEXT_PUBLIC_SNAPCHAT_PIXEL_ID;
export const NEXT_PUBLIC_SNAPCHAT_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_SNAPCHAT_LOGGING_ENABLED === 'true';

// OpenAI Ads
export const NEXT_PUBLIC_OPENAI_ADS_DISABLED =
  process.env.NEXT_PUBLIC_OPENAI_ADS_DISABLED === 'true';
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
export const NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID = process.env.NEXT_PUBLIC_OPENAI_ADS_PIXEL_ID;
export const NEXT_PUBLIC_OPENAI_ADS_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_OPENAI_ADS_LOGGING_ENABLED === 'true';

// Podscribe
export const NEXT_PUBLIC_PODSCRIBE_DISABLED = process.env.NEXT_PUBLIC_PODSCRIBE_DISABLED === 'true';

// Adalyser (UK BVOD campaign)
export const NEXT_PUBLIC_ADALYSER_DISABLED = process.env.NEXT_PUBLIC_ADALYSER_DISABLED === 'true';

// Meta Pixel
export const NEXT_PUBLIC_META_PIXEL_DISABLED =
  process.env.NEXT_PUBLIC_META_PIXEL_DISABLED === 'true';
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
export const NEXT_PUBLIC_META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;
export const NEXT_PUBLIC_META_PIXEL_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_META_PIXEL_LOGGING_ENABLED === 'true';

// Mapbox
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
const mapboxAccessToken = process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN;

// Fails the build rather than shipping a blank map that gives no signal about the cause.
if (!mapboxAccessToken) {
  throw new Error('Missing required environment variable: NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN');
}

export const NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN = mapboxAccessToken;

// Algolia
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
const algoliaAppId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
const algoliaApiKey = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY;

// Fails the build rather than shipping a search box that 403s against Algolia with no signal about the cause. A default here would also put a credential back in the public bundle.
if (!algoliaAppId) {
  throw new Error('Missing required environment variable: NEXT_PUBLIC_ALGOLIA_APP_ID');
}

if (!algoliaApiKey) {
  throw new Error('Missing required environment variable: NEXT_PUBLIC_ALGOLIA_API_KEY');
}

export const NEXT_PUBLIC_ALGOLIA_APP_ID = algoliaAppId;
export const NEXT_PUBLIC_ALGOLIA_API_KEY = algoliaApiKey;

// DISCOVER
export const NEXT_PUBLIC_DISCOVER_REGION_IDS = (process.env.NEXT_PUBLIC_DISCOVER_REGION_IDS || '6')
  .split(',')
  .map(Number);

export const NEXT_PUBLIC_DISCOVER_DEV_MENU_ENABLED =
  process.env.NEXT_PUBLIC_DISCOVER_DEV_MENU_ENABLED === 'true';

export const NEXT_PUBLIC_DISCOVER_PAGE_SIZE = Number(
  process.env.NEXT_PUBLIC_DISCOVER_PAGE_SIZE || '10'
);

export const NEXT_PUBLIC_DISCOVER_INFINITE_SCROLL_DISABLED =
  process.env.NEXT_PUBLIC_DISCOVER_INFINITE_SCROLL_DISABLED === 'true';

export const NEXT_PUBLIC_DISCOVER_FILER_BY_SESSION =
  process.env.NEXT_PUBLIC_DISCOVER_FILER_BY_SESSION === 'true';

export const NEXT_PUBLIC_DISCOVER_FILTER_BY_DATE =
  process.env.NEXT_PUBLIC_DISCOVER_FILTER_BY_DATE === 'true';

export const NEXT_PUBLIC_RESTAURANT_PERFORMANCE_MONITORING_ENABLED =
  process.env.NEXT_PUBLIC_RESTAURANT_PERFORMANCE_MONITORING_ENABLED !== 'false';

export const NEXT_PUBLIC_IMAGE_DOMAIN =
  process.env.NEXT_PUBLIC_IMAGE_DOMAIN || 'images.firsttable.net';

export const NEXT_PUBLIC_SHOW_25_DISCOUNT = process.env.NEXT_PUBLIC_SHOW_25_DISCOUNT || 'false';

// Braze
export const NEXT_PUBLIC_BRAZE_ENABLED = process.env.NEXT_PUBLIC_BRAZE_ENABLED === 'true';
export const NEXT_PUBLIC_BRAZE_TRACK_ANONYMOUS =
  process.env.NEXT_PUBLIC_BRAZE_TRACK_ANONYMOUS === 'true';
export const NEXT_PUBLIC_BRAZE_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_BRAZE_LOGGING_ENABLED === 'true';

// Hotjar
export const NEXT_PUBLIC_HOTJAR_DISABLED = process.env.NEXT_PUBLIC_HOTJAR_DISABLED === 'true';
// eslint-disable-next-line prefer-destructuring -- Next requires literal `process.env.NEXT_PUBLIC_*` access for client bundles
export const NEXT_PUBLIC_HOTJAR_SITE_ID = process.env.NEXT_PUBLIC_HOTJAR_SITE_ID;
export const NEXT_PUBLIC_HOTJAR_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_HOTJAR_LOGGING_ENABLED === 'true';

// HubSpot
export const NEXT_PUBLIC_HUBSPOT_DISABLED = process.env.NEXT_PUBLIC_HUBSPOT_DISABLED === 'true';
export const NEXT_PUBLIC_HUBSPOT_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_HUBSPOT_LOGGING_ENABLED === 'true';

// Location
export const NEXT_PUBLIC_LOCATION_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_LOCATION_LOGGING_ENABLED === 'true';

// Consent
export const NEXT_PUBLIC_CONSENT_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_CONSENT_LOGGING_ENABLED === 'true';

// Signup attribution (UTM capture)
export const NEXT_PUBLIC_SIGNUP_ATTRIBUTION_LOGGING_ENABLED =
  process.env.NEXT_PUBLIC_SIGNUP_ATTRIBUTION_LOGGING_ENABLED === 'true';
